import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import api from '../services/api'
import { useBranding } from '../hooks/useBranding'
// t95 · en un PUESTO COMPARTIDO de la clínica, la pantalla de entrar es «¿Quién eres?» con nombre + PIN.
import { PuestoSinSesion, cabeceraDispositivo } from '../utils/pantallaDelPin'
import { Boton, Ico, InputPassword } from '../components/ui'
import MarcaBiango, { MARCA_NOMBRE } from '../components/MarcaBiango'
// t264d · el fondo de las pantallas de entrar de Biango (el mismo que el del portal del laboratorio, con SU paleta) y el
// efecto del ratón y los toques, que es solo de esta pantalla.
import { fondoEscena, CapasEscena } from '../utils/escenaBiango'
import EfectoEntrar from '../utils/efectoEntrar'
// 3-oct-2026 · ENTRAR CON FACE ID O LA HUELLA, solo dentro de la app del móvil (services/entradaBiometrica.js). En el
// navegador `estadoEnEsteMovil` contesta «no hay app» y esta pantalla es la de siempre.
import { estadoEnEsteMovil, guardarLlaves, leerLlaves, borrarLlaves, noPreguntar, marcarNoPreguntar, yaSePidioAlAbrir, apuntarPedidaAlAbrir, plataforma } from '../services/entradaBiometrica'
// 5-oct-2026 · y en el NAVEGADOR, la huella o la cara que este navegador registró (services/huellaOCara, que junta las dos),
// para entrar cuando la sesión se ha acabado; la oferta de dentro (components/OfertaHuellaOCara) no se repite si ya salió aquí.
import { credencialesDeEsteNavegador, entrarConHuella, explicarFalloHuella, apuntarOfrecida, enLaApp, prepararEntradaConHuella } from '../services/huellaOCara'
// t478 · las demás cuentas abiertas en este dispositivo, y «Añadir otra cuenta» (como Gmail: utils/cuentasDelDispositivo).
import { CuentasAbiertas } from '../utils/MenuDeCuentas'
import PieLegal from '../components/PieLegal'   // 5-nov-2026 · los datos legales que pide el banco del TPV virtual
import { t as i18nT, tx, marca, tDato } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)
// Lo que trae la dirección al venir a añadir una cuenta (/login?anadir=1&email=…): si se viene a eso, y con qué correo.
export function vieneAAnadir() { try { return new URLSearchParams(window.location.search).get('anadir') === '1' } catch (_) { return false } }
function correoDeLaDireccion() { try { return String(new URLSearchParams(window.location.search).get('email') || '').slice(0, 200) } catch (_) { return '' } }

// B-792 · a dónde lleva el logo de la pantalla de entrar.
const WEB_BIANGO = 'https://biango.es'

// ── LA PALETA DE BIANGO, ESCRITA AQUI A PROPOSITO ────────────────────────────────────────────
//
//  Esta pantalla NO se tiñe con el color de ninguna clinica: «el /login de la app es para todos
//  iguales, punto y final» (el dueño, 2-sep-2026). Por eso los colores NO salen de las variables de
//  la marca —que las pisa la clinica— sino del cuaderno de marca de Biango, que es de donde tienen
//  que salir: Carbon, Azul principal, Azul claro y los dos grises. Si algun dia cambia la marca, se
//  cambia aqui y en `branding/colores.css`, que son los dos sitios donde vive.
const B = {
  carbon: '#22252B',        // logotipo, texto y fondos oscuros
  azul: '#1E88E5',          // el arco (el logotipo)
  // 5-oct-2026: los BOTONES, en el principal de Biango para la interfaz (#1B2130, elegido por el dueño: «menos
  // llamativo»; con letra blanca 16:1), y los enlaces y el campo enfocado, en su acento (#465066, 8:1 sobre blanco).
  // Los mismos que index.css (--biango-principal, --biango-secundario). El azul de arriba se queda en el logotipo.
  boton: '#1B2130',
  enlace: '#465066',
  azulClaro: '#90CAF9',     // acentos sobre fondo oscuro
  gris: '#8C96A3',          // texto secundario
  grisClaro: '#F1F3F6',     // fondos de superficie
}

// t264d · LA ESCENA DE /login (el dueño: «mola la pantalla de fondo que has puesto al login de laboratorios, haz algo así
// más chulo en el /login de las clínicas»). Con los colores del cuaderno de marca (los de `B`), nunca los de una clínica:
// esta pantalla se pinta antes de saber de cuál se entra.
// 17-oct-2026 · Y ahora, LA MISMA que la de /lab. El dueño, con el dossier delante: «usa mejor el fondo que usas en el /lab,
// me gusta mucho más, además te pedí que lo pusieras en el login de las clínicas también». La versión «más vistosa» (más
// luz, la trama más marcada y un segundo arco fino) se queda fuera: las mismas luces, la misma trama, la misma máscara y el
// mismo arco que pages/lab/EscenaLab.jsx (PALETA_LAB), valor por valor. Lo único que conserva /login es su efecto (el halo
// que sigue al ratón y la pulsación), que va aparte, en utils/efectoEntrar.
const TURQUESA = '#0AA69B'
export const PALETA_ENTRAR = {
  fondo: '#0f131a',
  capas: [
    `radial-gradient(62% 52% at 6% 0%, color-mix(in srgb, ${B.azul} 40%, transparent) 0%, transparent 72%)`,
    'radial-gradient(52% 46% at 100% 100%, rgba(10,166,155,0.22) 0%, rgba(10,166,155,0) 70%)',
    'radial-gradient(40% 44% at 74% 48%, rgba(144,202,249,0.13) 0%, rgba(144,202,249,0) 72%)',
    'linear-gradient(165deg, #0f131a 0%, #161b24 46%, #1b2130 100%)',
  ],
  trama: 'rgba(255,255,255,0.075)', paso: 22, atributoTrama: { 'data-trama-entrar': '' },
  mascara: 'radial-gradient(ellipse 60% 70% at 22% 30%, #000 0%, transparent 76%)',
  mascaraMovil: 'radial-gradient(ellipse 90% 45% at 50% 0%, #000 0%, transparent 78%)',
  arco: {
    id: 'entrar-arco-luz', colores: [B.azul, B.azulClaro, TURQUESA], opacidad: 0.24,
    top: ['-4%', '-9%'], right: ['-30%', '-10%'], width: ['96%', 'min((60vw / var(--z, 1)), 820px)'],
    mascara: 'linear-gradient(180deg, #000 30%, transparent 92%)',
  },
}

export default function Login() {
  // Tablet VINCULADA (pantalla de espera de documentos): la PWA instalada arranca en "/" y cae
  // aquí sin sesión — pero una tablet de documentos debe volver SIEMPRE a su espera, sin login.
  // El personal puede entrar igualmente con /login?personal=1 (enlace "Acceso del personal").
  useEffect(() => {
    try {
      const t = localStorage.getItem('tablet_token')
      const esPersonal = new URLSearchParams(window.location.search).has('personal')
      if (t && !esPersonal) window.location.replace('/tablet/' + encodeURIComponent(t))
    } catch (_) {}
  }, [])
  const branding = useBranding()
  const [email, setEmail] = useState(() => correoDeLaDireccion())
  const [password, setPassword] = useState('')
  // t199 · lo que dijo el servidor al cerrar la sesión de una clínica dada de baja que ya pasó sus 30 días (services/api.js
  // lo deja aquí): se enseña al llegar, y se olvida para la próxima vez.
  const [error, setError] = useState(() => { try { return sessionStorage.getItem('biango:aviso-entrar') || '' } catch { return '' } })
  useEffect(() => { try { sessionStorage.removeItem('biango:aviso-entrar') } catch { /* sin almacenamiento */ } }, [])
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  // t95 · ¿ESTE ORDENADOR ES UN PUESTO COMPARTIDO? Lo dice el servidor con la llave del navegador (y la red de la clínica):
  // entonces se entra con nombre + PIN, y «Entrar con contraseña» / «Entrar con otra cuenta» llevan a lo de siempre.
  const [puesto, setPuesto] = useState(null)
  const [conFormulario, setConFormulario] = useState(false)
  useEffect(() => {
    let vivo = true
    const cab = cabeceraDispositivo()
    if (!cab['X-Dispositivo']) return undefined
    api.get('/puesto/personas', { headers: cab }).then((r) => { if (vivo && r && r.data && r.data.disponible === true) setPuesto(r.data) }).catch(() => {})
    return () => { vivo = false }
  }, [])
  const navigate = useNavigate()
  // Vinculación de tablet de documentos por código (ver bloque al pie del formulario).
  const [vincular, setVincular] = useState(false)
  const [codigoVinc, setCodigoVinc] = useState('')
  const [vinculando, setVinculando] = useState(false)
  const [errVinc, setErrVinc] = useState('')
  const vincularTablet = async () => {
    setVinculando(true); setErrVinc('')
    try {
      const { data } = await api.post('/tablet/vincular', { codigo: codigoVinc })
      try { localStorage.setItem('tablet_token', data.token) } catch (_) {}
      window.location.replace('/tablet/' + encodeURIComponent(data.token))
    } catch (e) {
      setErrVinc(e.response?.data?.error || i18nT('pages.Login.codigo_no_valido_o_caducado', 'Código no válido o caducado'))
      setVinculando(false)
    }
  }

  // La misma persona puede trabajar en dos clínicas del mismo grupo con el mismo correo. Cuando pasa,
  // el servidor NO elige por ella —entraría en la agenda y los pacientes de otra empresa sin avisar—:
  // devuelve la lista y aquí se pregunta.
  const [clinicasElegir, setClinicasElegir] = useState(null)

  // ── FACE ID O LA HUELLA (3-oct-2026) ─────────────────────────────────────────────────────────
  // `bio`: lo que hay en ESTE móvil y si el servidor la tiene (null en el navegador o mientras se mira).
  // `oferta`: tras entrar con la contraseña, «¿Entrar con Face ID la próxima vez?» antes de seguir.
  // `elegirCon`: con qué se está eligiendo clínica (la contraseña o la llave de este móvil).
  const [bio, setBio] = useState(null)
  const [oferta, setOferta] = useState(null)
  const [activando, setActivando] = useState(false)
  const [entrandoBio, setEntrandoBio] = useState(false)
  const [elegirCon, setElegirCon] = useState('password')
  const llavesLeidas = useRef(null)
  const irDentro = (ag) => { window.location.href = ag?.rol === 'control_horario' ? '/fichar' : '/' }

  // t169 (10-oct-2026) · SE ENTRA EN UNA PESTAÑA Y ENTRAN TODAS. El dueño: «estoy en login, pongo la huella, me lleva a la
  // pestaña para poner mi contraseña, me saca y hago un bucle raro como 4-5 veces hasta que entra». Con varias pestañas de
  // Biango abiertas, al acabarse la sesión todas acaban aquí, y había que volver a entrar en cada una (la huella otra vez,
  // pestaña por pestaña). Ahora, cuando otra pestaña de este navegador entra (deja la llave nueva en el almacén, que es de
  // todas: el evento `storage`), esta entra con ella.
  useEffect(() => {
    if (typeof window === 'undefined' || !window.addEventListener) return undefined
    const alEntrarOtra = (e) => {
      if (!e || e.key !== 'token' || !e.newValue) return
      let ag = null
      try { ag = JSON.parse(localStorage.getItem('user') || 'null') } catch (_) { ag = null }
      if (ag && ag.id) irDentro(ag)
    }
    window.addEventListener('storage', alEntrarOtra)
    return () => window.removeEventListener('storage', alEntrarOtra)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const mostrarErrorDeEntrada = (err, porDefecto) => {
    if (!err?.response) setError(i18nT('pages.Login.no_se_ha_podido_conectar', 'No se ha podido conectar con el servidor. Si acabamos de actualizar la aplicación, espera unos segundos y vuelve a intentarlo.'))
    else if (err.response.status === 429) setError(err.response.data?.error || i18nT('pages.Login.demasiados_intentos_espera_unos_minutos', 'Demasiados intentos. Espera unos minutos.'))
    else if (err.response.status >= 500) setError(i18nT('pages.Login.el_servidor_ha_tenido_un', 'El servidor ha tenido un problema. Inténtalo de nuevo en un momento.'))
    else setError(err.response.data?.error || porDefecto)
  }

  // Entrar con la llave de este móvil: el sistema pide la cara o la huella y, con la llave, el servidor da la misma
  // sesión que con la contraseña (también el «¿en qué clínica entras?» si la cuenta tiene varias).
  const entrarConBiometria = async (clinicaId = null) => {
    setError('')
    let tokens = clinicaId ? llavesLeidas.current : null
    if (!tokens) {
      const r = await leerLlaves('equipo', { motivo: i18nT('pages.Login.entrar_en_biango_sin_escribir', 'Entrar en Biango sin escribir la contraseña'), titulo: i18nT('pages.Login.entrar_en_biango', 'Entrar en Biango') })
      if (r.enCurso || r.cancelado) return
      if (r.sinLlave) {
        await borrarLlaves('equipo')
        setBio((b) => (b ? { ...b, activada: false } : b))
        setError(i18nT('pages.Login.la_entrada_con_se_ha', 'La entrada con {{x}} se ha desactivado en este móvil (por ejemplo, al añadir una cara o una huella nueva). Entra con tu contraseña y vuelve a activarla.', { x: bio?.nombre || i18nT('pages.Login.la_huella_o_la_cara', 'la huella o la cara') }))
        return
      }
      if (r.error) { setError(i18nT('pages.Login.no_se_ha_podido_usar', 'No se ha podido usar {{x}}. Entra con tu contraseña.', { x: bio?.nombre || i18nT('pages.Login.la_huella_o_la_cara', 'la huella o la cara') })); return }
      tokens = r.tokens
    }
    setEntrandoBio(true)
    const aElegir = (data) => { llavesLeidas.current = tokens; setElegirCon('bio'); setClinicasElegir(data.clinicas || []) }
    try {
      const res = await api.post('/auth/biometria/entrar', { tokens, ...(clinicaId ? { clinica_id: clinicaId } : {}) })
      if (res.status === 300 && res.data?.elegir_clinica) { aElegir(res.data); return }
      llavesLeidas.current = null
      login(res.data.agente, res.data.token)
      irDentro(res.data.agente)
    } catch (err) {
      if (err?.response?.status === 300 && err.response.data?.elegir_clinica) { aElegir(err.response.data); return }
      if (err?.response?.data?.olvidar) {
        // La llave ya no vale (cambio de contraseña, quitada, caducada): fuera de este móvil y a la contraseña.
        llavesLeidas.current = null
        const publicos = await borrarLlaves('equipo')
        if (publicos.length) api.post('/auth/biometria/olvidar', { tokens_publicos: publicos }).catch(() => {})
        setBio((b) => (b ? { ...b, activada: false } : b))
      }
      mostrarErrorDeEntrada(err, 'No se ha podido entrar. Entra con tu contraseña.')
    } finally {
      setEntrandoBio(false)
    }
  }

  // Al abrir la pantalla en la app: ¿hay biometría, la tiene el servidor, está activada aquí? Si lo está, se pide la
  // cara o la huella UNA vez por arranque de la app (al salir de la sesión no se pide sola: queda el botón).
  useEffect(() => {
    let vivo = true
    estadoEnEsteMovil('equipo').then(async (e) => {
      if (!vivo || !e.app) return
      let servidor = false
      try { servidor = (await api.get('/auth/biometria/disponible')).data?.disponible === true } catch (_) { servidor = false }
      if (!vivo) return
      const est = { ...e, servidor }
      setBio(est)
      // t169c · también en el iPhone, UNA vez al abrir la app (una hoja a la vez: utils/faceIdUnaVez). Si se cancela, el botón.
      if (est.servidor && est.activada && est.puede && !yaSePidioAlAbrir()) { apuntarPedidaAlAbrir(); entrarConBiometria() }
    })
    return () => { vivo = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ── EN EL NAVEGADOR: ENTRAR CON LA HUELLA O LA CARA QUE ESTE NAVEGADOR REGISTRÓ (5-oct-2026) ──────────────────
  // Si en este navegador se activó (Mi perfil o la oferta de dentro), al acabarse la sesión aquí se entra con el dedo o la
  // cara en vez de la contraseña. Sale el botón (los navegadores no dejan pedir la huella sin que se pulse algo). Lo que
  // falla se dice en cristiano; si el servidor dice que ya no vale, se olvida aquí y queda la contraseña.
  const [webHuella, setWebHuella] = useState(false)
  const [entrandoWeb, setEntrandoWeb] = useState(false)
  useEffect(() => { try { setWebHuella(!enLaApp() && credencialesDeEsteNavegador().length > 0) } catch (_) { setWebHuella(false) } }, [])
  // t169c · con el botón a la vista, el reto se pide YA: al tocar, la hoja sale dentro del toque (Safari no la abre si antes
  // hay que esperar al servidor). (Una pantalla vieja de las pruebas sin esta función sigue como antes.)
  const prepararToque = () => { try { if (typeof prepararEntradaConHuella === 'function') prepararEntradaConHuella() } catch (_) { /* sin red: el toque lo pide */ } }
  useEffect(() => { if (webHuella) prepararToque() }, [webHuella])
  const entrarConHuellaWeb = async () => {
    setError(''); setEntrandoWeb(true)
    try {
      const d = await entrarConHuella()
      if (d && d.enCurso) return   // t169b · ya hay una hoja abierta: este toque no pide otra
      if (d && d.token && d.agente) { login(d.agente, d.token); irDentro(d.agente); return }
      if (d && d.olvidar) { setWebHuella(false); setError(d.error || i18nT('pages.Login.la_huella_de_este_navegador', 'La huella de este navegador ya no vale. Entra con tu contraseña.')) }
    } catch (err) {
      if (err?.response) mostrarErrorDeEntrada(err, 'No se ha podido entrar con la huella. Entra con tu contraseña.')
      else setError(explicarFalloHuella(err))
      prepararToque()   // t169c · el reto del siguiente toque, ya
    } finally { setEntrandoWeb(false) }
  }

  // «¿Entrar con Face ID la próxima vez?»: solo en la app, con biometría puesta en el móvil, con el servidor listo, si no
  // está ya activada aquí y no ha dicho «Ahora no». Ni para la cuenta del quiosco de fichar ni para quien tiene que
  // cambiar la contraseña (al cambiarla, la llave moriría al momento).
  const debeOfrecer = (ag) => !!(bio && bio.app && bio.puede && bio.servidor && !bio.activada && !noPreguntar('equipo')
    && ag && ag.rol !== 'control_horario' && !ag.must_change_password)

  const activarBiometria = async () => {
    setActivando(true)
    setError('')
    let creadas = null
    try {
      const { data } = await api.post('/auth/biometria/activar', { email, password, plataforma: plataforma() })
      creadas = data
      await guardarLlaves('equipo', { tokens: data.tokens, publicos: data.publicos })
      setPassword('')
      irDentro(oferta?.ag)
    } catch (err) {
      // Si el servidor la creó pero el móvil no la ha guardado (se canceló la huella), se apaga para no dejarla suelta.
      if (creadas?.publicos?.length) api.post('/auth/biometria/olvidar', { tokens_publicos: creadas.publicos }).catch(() => {})
      setActivando(false)
      setError(err?.response?.data?.error || i18nT('pages.Login.no_se_ha_podido_activar', 'No se ha podido activar ahora. Puedes hacerlo más tarde en Mi perfil, Seguridad.'))
    }
  }

  const handleSubmit = async (e, clinicaId = null) => {
    if (e) e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await api.post('/auth/login', { email, password, ...(clinicaId ? { clinica_id: clinicaId } : {}) })
      // 300 = las credenciales son buenas, pero falta decir en qué clínica se entra.
      if (res.status === 300 && res.data?.elegir_clinica) {
        setElegirCon('password')
        setClinicasElegir(res.data.clinicas || [])
        setLoading(false)
        return
      }
      const ag = res.data.agente
      login(ag, res.data.token)
      // FACE ID O LA HUELLA (3-oct-2026): en la app, antes de seguir se ofrece una vez. La sesión ya está abierta; si
      // dice «Ahora no» o la activa, se sigue exactamente como abajo.
      if (debeOfrecer(ag)) { apuntarOfrecida(); setOferta({ ag }); setLoading(false); return }
      // ENTRAR TRAE CODIGO FRESCO. Igual que al salir: `navigate()` no vuelve a pedir index.html, y
      // como la aplicación es una sola página, el navegador podía seguir ejecutando el código de
      // hace días. Entrar es el momento perfecto para recargar: pasa una vez, y garantiza que quien
      // acaba de entrar está usando la versión que hay hoy en el servidor — que es justo lo que
      // fallaba cuando un arreglo "ya estaba subido" y a él le seguía pasando lo mismo.
      // A DÓNDE SE ENTRA ya no se decide aquí. La pantalla de aterrizaje es una preferencia de cada
      // persona ("Al entrar, llévame a…", en Mi perfil) y vive en el servidor, que en este punto
      // todavía no se ha preguntado. Se manda a la raíz y es HomeRedirect quien resuelve el destino
      // con esa preferencia; sin ella, la página de inicio del equipo. El quiosco de fichar va
      // directo a lo suyo: es una cuenta compartida y no aterriza en pantallas del equipo.
      window.location.href = ag?.rol === 'control_horario' ? '/fichar' : '/'
    } catch (err) {
      // axios trata el 300 como error salvo que se le diga lo contrario: se mira también aquí para no
      // depender de cómo esté configurado el cliente.
      if (err?.response?.status === 300 && err.response.data?.elegir_clinica) {
        setElegirCon('password')
        setClinicasElegir(err.response.data.clinicas || [])
      } else if (!err?.response) {
        // NO HAY RESPUESTA: el servidor no ha contestado. Pasa mientras se reinicia tras un despliegue
        // (unos segundos) y cuando no hay red. Decir "contraseña incorrecta" ahi es mentir, y hace que
        // la persona dude de su clave y la teclee cinco veces mas — que es exactamente lo que la
        // bloquea por intentos. Paso de verdad el 18-ago-2026.
        setError(i18nT('pages.Login.no_se_ha_podido_conectar', 'No se ha podido conectar con el servidor. Si acabamos de actualizar la aplicación, espera unos segundos y vuelve a intentarlo.'))
      } else if (err.response.status === 429) {
        // El servidor SI manda "Demasiados intentos. Espera 15 minutos" — y se estaba tirando a la
        // basura, con lo que la pantalla seguia diciendo que la contraseña estaba mal.
        setError(err.response.data?.error || i18nT('pages.Login.demasiados_intentos_espera_unos_minutos', 'Demasiados intentos. Espera unos minutos.'))
      } else if (err.response.status >= 500) {
        setError(i18nT('pages.Login.el_servidor_ha_tenido_un', 'El servidor ha tenido un problema. Inténtalo de nuevo en un momento.'))
      } else {
        setError(err.response.data?.error || i18nT('pages.Login.email_o_contrasena_incorrectos', 'Email o contraseña incorrectos'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Estilo compartido de los campos (tokens → dark-safe).
  const inputStyle = {
    width: '100%', padding: '11px 13px',
    background: 'var(--surface-2)', color: 'var(--text-primary)',
    border: '1px solid var(--border)', borderRadius: 'var(--radius)',
    fontSize: '14px', outline: 'none',
  }
  const labelStyle = {
    display: 'block', fontSize: '13px', fontWeight: 600,
    color: 'var(--text-secondary)', marginBottom: '6px',
  }

  if (puesto && !conFormulario) {
    return (
      <PuestoSinSesion api={api} datos={puesto} cabeceras={cabeceraDispositivo()}
        onEntrar={(d) => { login(d.agente, d.token); window.location.href = d.agente && d.agente.rol === 'control_horario' ? '/fichar' : '/' }}
        onConContrasena={(correo) => { setEmail(correo || ''); setConFormulario(true) }}
        onOtraCuenta={() => { setEmail(''); setConFormulario(true) }} />
    )
  }

  return (
    <div className="login-escena" style={{ ...fondoEscena(PALETA_ENTRAR), display: 'flex' }}>
      {/* t264d · el fondo por capas (debajo de todo) y el efecto del ratón y los toques (encima del fondo y DEBAJO del
          contenido, sin coger ni un clic: utils/efectoEntrar). */}
      {/* Las dos formas (la del móvil y la ancha); el corte, en la hoja de estilos de abajo, con el mismo de siempre. */}
      <CapasEscena paleta={PALETA_ENTRAR} movil="css" />
      <EfectoEntrar color={B.azul} colorPunto={B.azulClaro} />
      {/* ── PANEL DE MARCA (solo en pantallas anchas) ────────────────────────────────────────
          Carbon de fondo y los dos azules del cuaderno en los halos. Sin una sola variable de
          marca: aqui manda Biango, no la clinica de turno. */}
      <div style={{
        flex: 1.15, display: 'none', background: 'transparent',
        flexDirection: 'column', justifyContent: 'center', padding: 'clamp(48px, (6vw / var(--z, 1)), 88px)',
        position: 'relative', overflow: 'hidden',
      }} className="login-left">
        {/* t264d · el arco y la luz del panel son ahora los de la escena (CapasEscena), que van por debajo de las dos columnas. */}
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 560 }}>
          {/* B-792 · el logotipo de Biango lleva a su web (el dueño: «enlazar logo biango a la web»). En otra pestaña,
              para no perder la pantalla de entrar. */}
          <a href={WEB_BIANGO} target="_blank" rel="noopener noreferrer" data-logo-a-la-web title={i18nT('pages.Login.ir_a_biango_es', 'Ir a biango.es')}
            style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: 'clamp(40px, (7vh / var(--z, 1)), 72px)', textDecoration: 'none', width: 'fit-content' }}>
            <MarcaBiango size={46} radio={13} />
            <span style={{ minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: '23px', fontWeight: 800, color: '#fff', letterSpacing: '-0.4px' }}>{MARCA_NOMBRE}</span>
              <span style={{ display: 'block', fontSize: '10.5px', fontWeight: 700, color: B.azulClaro, letterSpacing: '2.2px', marginTop: '3px' }}>
                {i18nT('pages.Login.gestiona_automatiza_crece', 'GESTIONA. AUTOMATIZA. CRECE.')}
              </span>
            </span>
          </a>
          <h2 style={{ fontSize: 'clamp(30px, (3.4vw / var(--z, 1)), 44px)', fontWeight: 800, color: '#fff', lineHeight: 1.08, letterSpacing: '-1px', marginBottom: '18px' }}>
            {i18nT('pages.Login.gestion_inteligente', 'Gestión inteligente')}<br />
            <span style={{ color: B.azulClaro }}>{i18nT('pages.Login.de_tu_clinica_dental', 'de tu clínica dental')}</span>
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.62)', fontSize: '15.5px', lineHeight: 1.65, maxWidth: '44ch' }}>
            {i18nT('pages.Login.conecta_con_tus_pacientes_automatiza', 'Conecta con tus pacientes, automatiza recordatorios y gestiona tu agenda en tiempo real.')}
          </p>
          <div style={{ marginTop: 'clamp(36px, (6vh / var(--z, 1)), 56px)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {[marca('pages.Login.historia_clinica_y_agenda_en', 'Historia clínica y agenda en un sitio'), marca('pages.Login.agenda_en_tiempo_real', 'Agenda en tiempo real'), marca('pages.Login.whatsapp_business_api', 'WhatsApp Business API')].map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: 'rgba(30,136,229,0.18)',
                  border: '1px solid rgba(144,202,249,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: B.azulClaro, flexShrink: 0 }}>
                  <Ico n="check" s={11} sw={3} c={B.azulClaro} />
                </div>
                <span style={{ color: 'rgba(255,255,255,0.72)', fontSize: '14.5px' }}>{tDato(f)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── COLUMNA DEL FORMULARIO ────────────────────────────────────────────────────────────
          En MOVIL esta columna es TODA la pantalla, asi que lleva su propia identidad: fondo carbon
          arriba con el arco, la tarjeta encima. Antes en movil no habia ni marca ni color — se
          entraba a un formulario gris que no decia de quien era. */}
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 'clamp(20px, (5vw / var(--z, 1)), 48px)', position: 'relative', background: 'transparent',
      }} className="login-right">
        {/* Franja de marca del movil: se apaga en escritorio (ahi ya esta el panel de la izquierda). */}
        <div aria-hidden="true" className="login-cinta" style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 'calc(38vh / var(--z, 1))', pointerEvents: 'none',
          // t264d · en el móvil, una luz más encima de la escena, detrás de la tarjeta.
          background: `radial-gradient(90% 100% at 50% 0%, color-mix(in srgb, ${B.azulClaro} 16%, transparent) 0%, transparent 75%)`,
        }} />

        <div className="login-tarjeta" style={{
          position: 'relative', zIndex: 1, width: '100%', maxWidth: '430px', color: 'var(--text-primary)',
          background: 'var(--surface)', border: '1px solid var(--border)',
          // t264d · flotando sobre la escena: sombras de varias distancias.
          borderRadius: '20px', boxShadow: '0 1px 0 rgba(255,255,255,.08) inset, 0 44px 96px -32px rgba(3,10,25,.75), 0 18px 40px -18px rgba(3,10,25,.5), 0 2px 6px rgba(3,10,25,.2)',
          padding: 'clamp(26px, (5vw / var(--z, 1)), 40px) clamp(20px, (4.5vw / var(--z, 1)), 36px)',
        }}>
          {/* t264d · el filo de luz de arriba, con los colores de Biango (como en la entrada del laboratorio). */}
          <span aria-hidden="true" style={{ position: 'absolute', left: 24, right: 24, top: 0, height: 3, borderRadius: '0 0 4px 4px',
            background: `linear-gradient(90deg, ${B.azul}, ${B.azulClaro} 55%, ${TURQUESA})` }} />
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <a href={WEB_BIANGO} target="_blank" rel="noopener noreferrer" data-logo-a-la-web title={i18nT('pages.Login.ir_a_biango_es', 'Ir a biango.es')} aria-label={i18nT('pages.Login.biango_ir_a_biango_es', 'Biango: ir a biango.es')}
              style={{ display: 'block', width: '58px', height: '58px', margin: '0 auto 18px' }}>
              <MarcaBiango size={58} radio={16} />
            </a>
            <h1 style={{ fontSize: 'clamp(21px, (5vw / var(--z, 1)), 25px)', fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '-0.5px', marginBottom: '6px' }}>
              {i18nT('pages.Login.bienvenido', 'Bienvenido')}
            </h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
              {i18nT('pages.Login.inicia_sesion_en_tu_cuenta', 'Inicia sesión en tu cuenta de Biango')}
            </p>
          </div>
          {/* t478 · las cuentas que siguen abiertas en este dispositivo (volver a una con un toque) y, si se viene a añadir
              una, dicho arriba. Sin ninguna, no pinta nada. */}
          <CuentasAbiertas anadiendo={vieneAAnadir()} />
          {/* ── ¿EN QUÉ CLÍNICA ENTRAS? ──
              Solo aparece cuando el mismo correo y la misma contraseña valen en más de una. Antes se
              elegía sola —la fila que Postgres devolviera primero— y la persona acababa dentro de
              otra empresa sin enterarse. */}
          {clinicasElegir && (
            <div style={{ marginBottom: '18px' }}>
              <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '4px', color: 'var(--text-primary)' }}>{i18nT('pages.Login.en_que_clinica_quieres_entrar', '¿En qué clínica quieres entrar?')}</div>
              <div style={{ fontSize: '12.5px', color: 'var(--text-secondary)', marginBottom: '10px', lineHeight: 1.5 }}>
                {i18nT('pages.Login.tu_correo_esta_dado_de', 'Tu correo está dado de alta en varias. Elige una; podrás salir y entrar en la otra cuando quieras.')}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* TARJETAS con el logo de cada clinica (lo pidio el dueño con esas palabras). El
                    logo viene del branding en la respuesta 300 — solo de las clinicas donde la
                    contraseña ya valido. Sin logo, la inicial en un circulo con su color de marca:
                    una tarjeta vacia no ayuda a distinguir dos clinicas del mismo grupo. */}
                {clinicasElegir.map(c => (
                  <button key={c.clinica_id} type="button" disabled={loading || entrandoBio}
                    onClick={() => (elegirCon === 'bio' ? entrarConBiometria(c.clinica_id) : handleSubmit(null, c.clinica_id))}
                    style={{ ...inputStyle, textAlign: 'left', cursor: loading ? 'wait' : 'pointer', fontWeight: 700,
                      display: 'flex', alignItems: 'center', gap: '12px', height: 'auto', padding: '10px 14px' }}>
                    {c.logo
                      ? <img src={c.logo} alt="" style={{ width: 38, height: 38, objectFit: 'contain', borderRadius: 8, flexShrink: 0, background: '#fff' }} />
                      : <span aria-hidden="true" style={{ width: 38, height: 38, borderRadius: 8, flexShrink: 0, display: 'inline-flex',
                          alignItems: 'center', justifyContent: 'center', fontSize: 17, fontWeight: 800, color: c.color ? '#fff' : 'var(--sobre-primary)',
                          background: c.color || 'var(--primary)' }}>{(c.nombre || '?').trim().charAt(0).toUpperCase()}</span>}
                    {/* t643 · la prueba de su migración se entiende (y el servidor la pone delante de su clínica) */}
                    {c.prueba_migracion
                      ? <span data-tarjeta-prueba="" style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                          <span>{i18nT('pages.Login.prueba_de_tu_migracion', 'Prueba de tu migración, para revisar')}</span>
                          <span style={{ fontSize: '12px', fontWeight: 500, color: 'var(--text-secondary)', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.nombre}</span>
                        </span>
                      : <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.nombre}</span>}
                  </button>
                ))}
                <button type="button" onClick={() => { setClinicasElegir(null); llavesLeidas.current = null }}
                  style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '12.5px', cursor: 'pointer', padding: '4px 0' }}>
                  {i18nT('pages.Login.volver', 'Volver')}
                </button>
              </div>
            </div>
          )}

          {/* ── «¿ENTRAR CON FACE ID LA PRÓXIMA VEZ?» (3-oct-2026) ──
              Sale una vez, justo después de entrar con la contraseña, solo en la app del móvil. Se guarda una llave de
              ESTE móvil en su llavero seguro, protegida por la cara o la huella: nunca la contraseña. */}
          {oferta && bio && (
            <div data-oferta-biometria style={{ marginBottom: '6px' }}>
              <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '8px' }}>
                {tx('pages.Login.entrar_con_la_proxima_vez', '¿Entrar con {{nombre}} la próxima vez?', { nombre: bio.nombre })}
              </div>
              <div style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.55, marginBottom: '16px' }}>
                {i18nT('pages.Login.asi_no_tendras_que_escribir', 'Así no tendrás que escribir la contraseña en este móvil. Tu cara o tu huella no salen del móvil y tu contraseña no se guarda: se guarda una llave de este móvil, que puedes quitar cuando quieras en Mi perfil, Seguridad.')}
              </div>
              {error && (
                <div style={{ color: 'var(--danger)', fontSize: '13px', marginBottom: '12px' }}>{error}</div>
              )}
              <Boton className="login-boton" type="button" variante="primario" disabled={activando} onClick={activarBiometria}
                style={{ width: '100%', justifyContent: 'center', padding: '13px', fontSize: '14px', fontWeight: 800,
                  background: B.boton, border: 'none', color: '#fff', borderRadius: '12px' }}>
                {activando ? i18nT('pages.Login.activando', 'Activando...') : i18nT('pages.Login.si_activar', 'Sí, activar {{nombre}}', { nombre: bio.nombre })}
              </Boton>
              <button type="button" disabled={activando} onClick={() => { marcarNoPreguntar('equipo'); setPassword(''); irDentro(oferta.ag) }}
                style={{ display: 'block', width: '100%', marginTop: '10px', background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '13px', cursor: 'pointer', padding: '8px 0' }}>
                {i18nT('pages.Login.ahora_no', 'Ahora no')}
              </button>
            </div>
          )}

          {/* ENTRAR CON FACE ID O LA HUELLA: solo si está activada en ESTE móvil (y el servidor la tiene). */}
          {bio && bio.servidor && bio.activada && bio.puede && !oferta && !clinicasElegir && (
            <div style={{ marginBottom: '18px' }}>
              <Boton className="login-boton" type="button" variante="primario" disabled={entrandoBio} onClick={() => entrarConBiometria()} data-entrar-biometria
                style={{ width: '100%', justifyContent: 'center', padding: '13px', fontSize: '14px', fontWeight: 800,
                  background: B.boton, border: 'none', color: '#fff', borderRadius: '12px' }}>
                {entrandoBio ? i18nT('pages.Login.entrando', 'Entrando...') : i18nT('pages.Login.entrar_con', 'Entrar con {{nombre}}', { nombre: bio.nombre })}
              </Boton>
              <div style={{ textAlign: 'center', fontSize: '12.5px', color: 'var(--text-muted)', marginTop: '12px' }}>{i18nT('pages.Login.o_con_tu_contrasena', 'o con tu contraseña')}</div>
            </div>
          )}

          {/* EN EL NAVEGADOR: entrar con la huella o la cara registrada en ESTE navegador (5-oct-2026). */}
          {webHuella && !(bio && bio.activada) && !oferta && !clinicasElegir && (
            <div style={{ marginBottom: '18px' }}>
              <Boton className="login-boton" type="button" variante="primario" disabled={entrandoWeb} onClick={() => entrarConHuellaWeb()} data-entrar-huella-navegador
                style={{ width: '100%', justifyContent: 'center', padding: '13px', fontSize: '14px', fontWeight: 800,
                  background: B.boton, border: 'none', color: '#fff', borderRadius: '12px' }}>
                {entrandoWeb ? i18nT('pages.Login.entrando', 'Entrando...') : i18nT('pages.Login.entrar_con_la_huella_o', 'Entrar con la huella o la cara')}
              </Boton>
              <div style={{ textAlign: 'center', fontSize: '12.5px', color: 'var(--text-muted)', marginTop: '12px' }}>{i18nT('pages.Login.o_con_tu_contrasena', 'o con tu contraseña')}</div>
            </div>
          )}

          <form onSubmit={handleSubmit} style={clinicasElegir || oferta ? { display: 'none' } : undefined}>
            <div style={{ marginBottom: '16px' }}>
              <label style={labelStyle} htmlFor="email">{i18nT('pages.Login.email', 'Email')}</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="tu@clinica.es" required
                name="email" id="email" autoComplete="username"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={labelStyle} htmlFor="password">{i18nT('pages.Login.contrasena', 'Contraseña')}</label>
              {/* Ojo de mostrar/ocultar: el sitio donde más se teclea a ciegas de toda la app. */}
              <InputPassword
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" required
                name="password" id="password" autoComplete="current-password"
                style={inputStyle}
              />
            </div>

            {/* Sin esto, quien olvida la contraseña tiene que llamar a la clínica para que se la
                cambien a mano — y ahí acaba habiendo alguien tecleando una contraseña por teléfono. */}
            <div style={{ textAlign: 'right', marginTop: '-16px', marginBottom: '18px' }}>
              <a href="/olvide-mi-contrasena" style={{ fontSize: '12.5px', fontWeight: 700, color: B.enlace, textDecoration: 'none' }}>
                {i18nT('pages.Login.he_olvidado_mi_contrasena', 'He olvidado mi contraseña')}
              </a>
            </div>

            {error && (
              <div style={{
                background: 'var(--danger-bg)',
                border: '1px solid color-mix(in srgb, var(--danger) 40%, var(--border))',
                borderRadius: 'var(--radius)', padding: '10px 14px',
                color: 'var(--danger)', fontSize: '13px', marginBottom: '16px',
                display: 'flex', alignItems: 'center', gap: '8px',
              }}>
                <Ico n="info" s={15} sw={2} />
                {error}
              </div>
            )}

            <Boton className="login-boton"
              type="submit" variante="primario" disabled={loading}
              style={{
                width: '100%', justifyContent: 'center', padding: '11px',
                fontSize: '14px',
                // El color de BIANGO, no `--primary`: esa variable la pisa la clinica y aqui la
                // clinica no manda. Ver el bloque `B` de arriba.
                background: B.boton,
                border: 'none', color: '#fff', fontWeight: 800, letterSpacing: '.2px',
                borderRadius: '12px', padding: '13px',
                boxShadow: '0 8px 22px rgba(27,33,48,.28)',
              }}
            >
              {loading ? i18nT('pages.Login.entrando', 'Entrando...') : i18nT('pages.Login.iniciar_sesion', 'Iniciar sesión')}
            </Boton>
          </form>

          {/* Vincular esta pantalla como TABLET de documentos (iPad: la app instalada tiene
              almacenamiento propio y arranca aquí; se vincula tecleando el código que genera
              Administración → Tablets → Emparejar). Tras vincular, siempre abre en la espera. */}
          <div style={{ marginTop: 22, textAlign: 'center', ...(oferta ? { display: 'none' } : {}) }}>
            {!vincular ? (
              <button onClick={() => setVincular(true)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 12.5, cursor: 'pointer', textDecoration: 'underline' }}>
                {i18nT('pages.Login.es_esto_un_dispositivo_para', '¿Es esto un dispositivo para documentación? Vincular con código')}
              </button>
            ) : (
              <div style={{ border: '1px dashed var(--border)', borderRadius: 12, padding: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 8 }}>{i18nT('pages.Login.codigo_de_vinculacion_administracion_dis', 'Código de vinculación (Administración → Dispositivos de firma → Emparejar)')}</div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                  <input value={codigoVinc} onChange={e => setCodigoVinc(e.target.value.replace(/\D/g, '').slice(0, 6))} inputMode="numeric" placeholder="123456" autoFocus
                    style={{ ...inputStyle, width: 130, textAlign: 'center', letterSpacing: 4, fontWeight: 800, fontSize: 17 }} />
                  <Boton variante="primario" disabled={codigoVinc.length !== 6 || vinculando} onClick={vincularTablet}>{vinculando ? '…' : i18nT('pages.Login.vincular', 'Vincular')}</Boton>
                </div>
                {errVinc && <div style={{ marginTop: 8, fontSize: 12.5, color: 'var(--danger, #dc2626)', fontWeight: 600 }}>{errVinc}</div>}
                <button onClick={() => { setVincular(false); setErrVinc('') }} style={{ marginTop: 8, background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 12, cursor: 'pointer' }}>{i18nT('pages.Login.cancelar', 'Cancelar')}</button>
              </div>
            )}
          </div>
          <PieLegal />
        </div>
      </div>

      <style>{`
        /* B-868 · con el ANCHO EFECTIVO (clases de utils/uiScale), no con @media: el tamaño elegido en el perfil vale
           también aquí, y con «Muy grande» el panel de la izquierda ya no cabe. */
        :where(html.a-min-900) .login-left { display: flex !important; }
        /* En escritorio la identidad ya la pone el panel de la izquierda: la franja del movil
           sobra y taparia media columna. */
        :where(html.a-min-900) .login-cinta { display: none !important; }
        /* En movil la tarjeta baja para que se vea la franja de marca por encima de ella. */
        :where(html.a-max-899) .login-right { align-items: flex-start !important; padding-top: calc(15vh / var(--z, 1)) !important; }
        /* El campo enfocado se marca con el acento de Biango. Va en CSS y no en linea porque :focus no
           se puede escribir en un objeto de estilo, y sin esta señal en movil no se sabe en cual de
           los dos campos se esta escribiendo. */
        /* t264d · las capas de la escena: la forma del móvil o la ancha, con el corte de siempre (el ancho efectivo). */
        :where(html.a-min-900) .escena-capas-movil { display: none !important; }
        :where(html.a-max-899) .escena-capas-ancha { display: none !important; }
        /* t264d · en oscuro, «He olvidado mi contraseña» con el celeste de Biango: el gris azulado no se leía sobre la tarjeta oscura. */
        html.dark .login-right a[href="/olvide-mi-contrasena"] { color: ${B.azulClaro} !important; }
        /* t264f · en oscuro, los botones de entrar en el celeste de Biango con tinta oscura (#0f1720): 10,3:1 su letra y 7,5:1
           contra la tarjeta oscura (#2b313b). El carbón de los botones se hundía en ella. En claro, el de siempre. */
        html.dark .login-escena .login-boton { background: ${B.azulClaro} !important; color: #0f1720 !important; box-shadow: 0 12px 28px -10px rgba(144,202,249,.45) !important; }
        /* t264d · la tarjeta entra suave (y quieta con «reducir movimiento»). */
        .login-tarjeta { animation: login-entra .45s cubic-bezier(.2,.8,.2,1) both; }
        @keyframes login-entra { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: none; } }
        @media (prefers-reduced-motion: reduce) { .login-tarjeta { animation: none !important; } }
        .login-right input:focus {
          border-color: ${B.enlace} !important;
          box-shadow: 0 0 0 3px rgba(70,80,102,.18) !important;
        }
      `}</style>
    </div>
  )
}
